module.exports = __webpack_public_path__ + "static/img/jpg.63f035a9.png";